import { config } from "../../core/config/config.service.es.js";
let currentPosition = null;
const predictionsCache = new Object(null);
let placeService;
let autocompleteService;
let googleLocal;
let google;
const useGoogleAPI = () => ({
  askForLocation,
  getPlacePredictions,
  getPlaceAddress,
  parseCityFromComponents,
  parseStreetFromComponents,
  parseAddressComponents
});
const initGoogleAPI = async () => {
  await includeGoogleAPIScript();
};
const includeGoogleAPIScript = async () => {
  return new Promise((resolve, reject) => {
    const apiKey = config.googleMapsAPIKey;
    if (window.google && window.google.maps) {
      resolve(true);
      return;
    }
    if (!apiKey) {
      reject(new Error("Google Maps API key is not set, please update your config"));
      return;
    }
    const lang = document.documentElement.getAttribute("lang") || "en";
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&language=${lang}&callback=Function.prototype`;
    script.async = true;
    script.defer = true;
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      reject(new Error("Failed to load Google Maps script"));
    };
    document.head.appendChild(script);
    setWaitTimeout(100);
  });
};
const setupGoogleAPI = (newGoogle) => {
  google = newGoogle;
  googleLocal = typeof google === "undefined" ? null : google;
  if (!googleLocal) {
    setWaitTimeout(100);
  }
  autocompleteService = googleLocal && googleLocal.maps ? new googleLocal.maps.places.AutocompleteService(
    document.createElement("input")
  ) : {};
  placeService = googleLocal && googleLocal.maps ? new googleLocal.maps.places.PlacesService(document.createElement("div")) : {};
};
function askForLocation() {
  if (!currentPosition && navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        currentPosition = position.coords;
      },
      () => {
      },
      {
        enableHighAccuracy: false,
        maximumAge: 5e3
      }
    );
  }
}
function getPlacePredictions(input, types = "(cities)") {
  if (!googleLocal) {
    return Promise.reject(new Error("google not loaded"));
  }
  if (!input) {
    return Promise.resolve([]);
  }
  const hash = `${input}::${types}`;
  if (predictionsCache[hash]) {
    return Promise.resolve(predictionsCache[hash]);
  }
  return new Promise((resolve, reject) => {
    autocompleteService.getPlacePredictions(
      {
        input,
        types: [types],
        // specifying location and radius did not enhance results, for example for
        // Sedmerovec 93 address.. it did not find it neither
        // therefore I am not going to make code more complex, without any value
        ...currentPosition ? {
          radius: 5e3,
          location: new google.maps.LatLng(
            currentPosition.latitude,
            currentPosition.longitude
          )
        } : {
          // fallbacks to whole europe
          bounds: config.bounds || {
            east: -24.550781,
            south: 34.741612,
            west: 40.605468,
            north: 71.244356
          }
        }
      },
      (results, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK || status === google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
          predictionsCache[hash] = results;
          resolve(results ?? []);
        } else {
          reject({ results, status });
        }
      }
    );
  });
}
function getPlaceAddress(placeId) {
  return new Promise((resolve, reject) => {
    placeService.getDetails(
      {
        placeId,
        fields: ["address_components"]
      },
      (result, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          resolve(parseAddressComponents(result.address_components));
        } else {
          reject({ result, status });
        }
      }
    );
  });
}
function parseStreetFromComponents(components) {
  const street = components.route;
  const number = components.street_number || components.queryNumberParts || "";
  return street && number ? `${street} ${number}` : street || number;
}
function parseCityFromComponents(components) {
  return components.postal_town || components.locality || components.sublocality || components.sublocality_level_5 || components.sublocality_level_4 || components.sublocality_level_3 || components.sublocality_level_2 || components.sublocality_level_1 || components.administrative_area_level_5 || components.administrative_area_level_4 || components.administrative_area_level_3 || components.administrative_area_level_2 || components.administrative_area_level_1 || "";
}
function parseAddressComponents(address_components = []) {
  const parsed_components = {};
  const componentsLength = address_components.length;
  for (let i = 0; i < componentsLength; ++i) {
    const component = address_components[i];
    const types = component.types;
    for (let ii = 0; ii < types.length; ++ii) {
      const type = types[ii];
      parsed_components[type] = component.long_name;
      if (type === "country") {
        parsed_components.country_code = component.short_name;
      }
    }
  }
  return parsed_components;
}
function setWaitTimeout(time) {
  setTimeout(() => {
    if (time > 3e4) {
      return;
    }
    googleLocal = typeof window.google === "undefined" ? null : window.google;
    if (!googleLocal) {
      setWaitTimeout(time *= 2);
    } else {
      google = window.google;
      autocompleteService = new googleLocal.maps.places.AutocompleteService();
      placeService = new googleLocal.maps.places.PlacesService(
        document.createElement("div")
      );
    }
  }, time);
}
export {
  includeGoogleAPIScript,
  initGoogleAPI,
  setupGoogleAPI,
  useGoogleAPI
};
//# sourceMappingURL=googleAPI.service.es.js.map
